import { render, staticRenderFns } from "./UcFixedAssetRentals.yaml?vue&type=template&id=38834e83&component"
import script from "./UcFixedAssetRentals.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetRentals.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports